import { createApiClient } from './client'
import type {
  CreateTripFeedPostDto,
  TripFeedPost,
  TripFeedPostType,
  TripFeedReactionType,
} from './types'

export interface ListTripFeedParams {
  limit?: number
  before?: string
  postType?: TripFeedPostType
}

export class TripFeedApi {
  private apiClient: ReturnType<typeof createApiClient>

  constructor(getAuthToken: () => Promise<string | null>) {
    this.apiClient = createApiClient(getAuthToken)
  }

  async listPosts(tripId: string, params?: ListTripFeedParams): Promise<TripFeedPost[]> {
    const response = await this.apiClient.get<{ success: boolean; data: TripFeedPost[] }>(
      `/trips/${tripId}/feed`,
      params
    )
    return response.data
  }

  async createPost(tripId: string, payload: CreateTripFeedPostDto): Promise<TripFeedPost> {
    const response = await this.apiClient.post<{ success: boolean; data: TripFeedPost }>(
      `/trips/${tripId}/feed`,
      payload
    )
    return response.data
  }

  async deletePost(tripId: string, postId: string): Promise<void> {
    await this.apiClient.delete<{ success: boolean }>(`/trips/${tripId}/feed/${postId}`)
  }

  async togglePin(tripId: string, postId: string, isPinned: boolean): Promise<TripFeedPost> {
    const endpoint = `/trips/${tripId}/feed/${postId}/pin`
    const response = isPinned
      ? await this.apiClient.post<{ success: boolean; data: TripFeedPost }>(endpoint)
      : await this.apiClient.delete<{ success: boolean; data: TripFeedPost }>(endpoint)
    return response.data
  }

  async toggleReaction(
    tripId: string,
    postId: string,
    reactionType: TripFeedReactionType
  ): Promise<void> {
    await this.apiClient.post<{ success: boolean }>(`/trips/${tripId}/feed/${postId}/reactions`, {
      reactionType,
    })
  }
}
